module.exports = __webpack_public_path__ + "static/media/crossPopUp.8096b4de.svg";